import * as i0 from '@angular/core';
import { EventEmitter, Injectable, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

var OnlineStatusType;
(function (OnlineStatusType) {
    OnlineStatusType[OnlineStatusType["OFFLINE"] = 0] = "OFFLINE";
    OnlineStatusType[OnlineStatusType["ONLINE"] = 1] = "ONLINE";
})(OnlineStatusType || (OnlineStatusType = {}));

class OnlineStatusService {
    constructor() {
        this.status = new EventEmitter(true);
        this.bind();
        window.addEventListener(OnlineStatusService.EVENT_TYPE_ONLINE, this.onOnline);
        window.addEventListener(OnlineStatusService.EVENT_TYPE_OFFLINE, this.onOffline);
    }
    ngOnDestroy() {
        window.removeEventListener(OnlineStatusService.EVENT_TYPE_ONLINE, this.onOnline);
        window.removeEventListener(OnlineStatusService.EVENT_TYPE_OFFLINE, this.onOffline);
    }
    /**
     * getStatus - get online status
     *
     * @returns OnlineStatusType
     */
    getStatus() {
        if (navigator.onLine) {
            return OnlineStatusType.ONLINE;
        }
        return OnlineStatusType.OFFLINE;
    }
    bind() {
        this.onOnline = this.onOnline.bind(this);
        this.onOffline = this.onOffline.bind(this);
    }
    onOnline() {
        this.status.emit(OnlineStatusType.ONLINE);
    }
    onOffline() {
        this.status.emit(OnlineStatusType.OFFLINE);
    }
}
OnlineStatusService.EVENT_TYPE_ONLINE = 'online';
OnlineStatusService.EVENT_TYPE_OFFLINE = 'offline';
OnlineStatusService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: OnlineStatusService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
OnlineStatusService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: OnlineStatusService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: OnlineStatusService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

class OnlineStatusModule {
}
OnlineStatusModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: OnlineStatusModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OnlineStatusModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: OnlineStatusModule, imports: [CommonModule] });
OnlineStatusModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: OnlineStatusModule, providers: [
        OnlineStatusService
    ], imports: [[
            CommonModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: OnlineStatusModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [],
                    providers: [
                        OnlineStatusService
                    ]
                }]
        }] });

/**
 * Created by Vadym Yatsyuk on 27.01.18
 */

/**
 * Generated bundle index. Do not edit.
 */

export { OnlineStatusModule, OnlineStatusService, OnlineStatusType };
